import * as tslib_1 from "tslib";
import dashboardApi from '@/services/dashboard';
import { getState } from '@@/store';
import { useAntdTable } from 'ahooks';
import { Table } from 'antd';
import React from 'react';
import styled from 'styled-components';
const Root = styled.div ``;
const detailUrlPrefixTest = 'http://f2e.dasouche-inc.net/projects/data-fe/cybertron-pipeline-web/#/home/';
const detailUrlPrefixPro = 'https://f2e-assets.souche-inc.com/projects/data-fe/cybertron-pipeline-web/#/home/';
const detailUrlCooperationTest = 'http://f2e.dasouche-inc.net/projects/data-fe/cybertron-cooperation-web/index.html#/publishLibrary/';
const detailUrlCooperationPro = 'https://f2e-assets.souche-inc.com/projects/data-fe/cybertron-cooperation-web/index.html#/publishLibrary/';
const MyLibrary = ({ className, style }) => {
    const columns = [
        {
            title: 'appCode',
            dataIndex: 'appCode',
            width: '28%',
        },
        {
            title: '应用名称',
            dataIndex: 'appName',
            width: '28%',
            render: (text, record) => {
                const urlPrefix = process.env.MUJI_APP_ENV === 'prod'
                    ? detailUrlPrefixPro
                    : detailUrlPrefixTest;
                return (<a onClick={() => {
                    window.open(`${urlPrefix}${record.appId}/info`);
                }}>
            {text}
          </a>);
            },
        },
        {
            title: '应用区',
            dataIndex: 'appZone',
            width: '16%',
        },
        {
            title: '负责人',
            width: '16%',
            dataIndex: 'appPersonInCharge',
        },
        {
            title: '操作',
            dataIndex: 'id',
            render: (text, record) => {
                const urlPrefix = process.env.MUJI_APP_ENV === 'prod'
                    ? detailUrlCooperationPro
                    : detailUrlCooperationTest;
                return (<a onClick={() => {
                    window.open(`${urlPrefix}${record.appId}?appCode=${record.appCode}&appZone=${record.appZone}`);
                }}>
            去发布
          </a>);
            },
        },
    ];
    const getMyLibraryPage = (params) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield dashboardApi.fetchMyApp({
            pageIndex: params.current,
            pageSize: params.pageSize,
            userId: getState().global.sso.userInfo.email,
            appStatus: undefined,
            appType: 1,
            isLibrary: 1,
        }).promise;
    });
    const { tableProps } = useAntdTable(getMyLibraryPage, {
        defaultPageSize: 10,
        formatResult: (res) => {
            return {
                total: res.totalNumber,
                list: res.items,
            };
        },
    });
    return (<Root className={className} style={style}>
      <Table columns={columns} {...tableProps} scroll={{ y: 300 }} rowKey={'id'}/>
    </Root>);
};
export default MyLibrary;
